import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { ShopProvider } from "@/context/ShopContext";
import { Preloader } from "@/components/Preloader";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PerfumeModal } from "@/components/PerfumeModal";
import Home from "@/pages/Home";
import Parfums from "@/pages/Parfums";
import Admin from "@/pages/Admin";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ivory px-6 text-center">
          <div>
            <p className="font-serif text-4xl text-espresso">Vāsam</p>
            <p className="mt-4 text-sm text-espresso/60">Une erreur est survenue. Rechargez la page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.__lenis?.scrollTo?.(0, { immediate: true });
  }, [pathname]);
  return null;
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <>{children}</>;
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <PerfumeModal />
    </>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (loading) {
      window.__lenis?.stop?.();
      document.body.style.overflow = "hidden";
    } else {
      window.__lenis?.start?.();
      document.body.style.overflow = "";
    }
  }, [loading]);

  return (
    <ErrorBoundary>
      <ShopProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AnimatePresence>
            {loading && (
              <Preloader
                onDone={() => {
                  window.__introDone = true;
                  setLoading(false);
                }}
              />
            )}
          </AnimatePresence>
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/parfums" element={<Parfums />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Chrome>
        </BrowserRouter>
        <Toaster position="top-center" />
      </ShopProvider>
    </ErrorBoundary>
  );
}

export default App;
